import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { JobsService } from '@app/shared/jobs.service';
import { Job } from '@app/shared/shared.models';

@Component({
  selector: 'app-shared-featured-jobs',
  templateUrl: './featured-jobs.component.html',
  styleUrls: ['./featured-jobs.component.css'],
})
export class FeaturedJobsComponent implements OnInit {
  isLoading = false;
  jobs: Job[] = [];
  page = 0;

  private allFeaturedJobs: Job[] = [];
  private MAX_ELEMENTS = 3;

  constructor(private jobsService: JobsService, private router: Router) {}

  moreJobs() {
    if (this.page < 1) {
      this.jobs = this.allFeaturedJobs;
      this.page += 1;
    } else {
      this.router.navigate([`jobs/`]);
    }
  }

  ngOnInit() {
    this.isLoading = true;
    this.jobsService
      .featuredJobs()
      .then((response) => {
        this.allFeaturedJobs = response;
        if (this.allFeaturedJobs.length > this.MAX_ELEMENTS) {
          this.jobs = this.allFeaturedJobs.slice(0, this.MAX_ELEMENTS);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
